import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { getComsAcsDataTableStructure } from './utils/acs-data-table-object';

@Component({
  selector: 'sm-acs-coms',
  imports: [CommonModule, DataTableBuilderComponent],
  templateUrl: './acs-coms.component.html',
  styleUrl: './acs-coms.component.scss',
})
export class AcsComsComponent implements OnChanges {
  @Input() committeeId!: string;
  @Input() acs?: any[];
  @Input() isInspectMode!: boolean;

  dataTableObject: any = getComsAcsDataTableStructure();

  ngOnChanges(changes: any) {
    if (changes['acs'] && this.acs) {
      this.dataTableObject = getComsAcsDataTableStructure();
    }
  }
}
